<template>
  <v-dialog width="500" v-model="dialog" persistent>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Are you still there?
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        You haven't been active for more than 30 minutes. For security reasons,
        we will be logging you out automatically in {{ seconds }} seconds.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="refreshTokenAndContinue()">
          Wait! I am still here
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { setTimeout } from 'timers'
import Auth from '@/modules/auth/models/Auth'
import { TokenService } from '@/services/storage.service'
import authLogout from '@/modules/auth/mixins/authLogout'

export default {
  name: 'Inactive',
  mixins: [authLogout],
  data() {
    return {
      dialog: false,
      seconds: 60,
      timer: null
    }
  },
  computed: {
    me() {
      return Auth.query()
        .where('type', this.$route.meta.type)
        .first()
    }
  },
  mounted() {
    this.timer = this.calculateElapsedTime()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    refreshTokenAndContinue() {
      this.dialog = false
      Auth.dispatch('resetActivity', `${this.$route.meta.type}s`)
    },
    calculateElapsedTime() {
      const halfAnHourAgo = this.$moment()
        .utc()
        .subtract(30, 'minutes')
        .unix()
      const lastActivity = parseInt(
        TokenService.getToken(`${this.$route.meta.type}-last-activity`)
      )
      console.log(((lastActivity - halfAnHourAgo) / 60).toFixed(2))
      if (lastActivity < halfAnHourAgo && !this.dialog) {
        this.showDialog()
      }
      this.timer = setTimeout(this.calculateElapsedTime, 60000)
    },
    showDialog() {
      this.dialog = true
      setTimeout(this.checkAndLogout, 60000)
      setTimeout(this.decrementSecond, 1000)
    },
    decrementSecond() {
      if (this.seconds > 0) {
        this.seconds--
        setTimeout(this.decrementSecond, 1000)
      }
    },
    checkAndLogout() {
      if (this.dialog) {
        this.logout(this.$route.meta.type)
      } else {
        this.seconds = 60
      }
    }
  }
}
</script>

<style lang="scss"></style>
